// Упрощённая проверка формата: окончательно адрес проверяет сервер,
// отправляя на него письмо с подтверждением.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const EMAIL_MAX_LENGTH = 254;

export const validateEmail = (
  email: string,
  currentEmail: string | null,
): string | null => {
  if (!email) return "Enter a new email address.";
  if (email.length > EMAIL_MAX_LENGTH || !EMAIL_PATTERN.test(email)) {
    return "Enter a valid email address.";
  }
  if (email.toLowerCase() === currentEmail?.toLowerCase()) {
    return "This is already your current email.";
  }
  return null;
};
